import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppErrors, NotFoundError } from '@fitness-force/errors';
import { CreateComments } from '@fitness-force/models';
import { environment } from 'apps/ff-frontend/src/environments/environment';
import { Observable, map, catchError, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommentsService {

  constructor(private http: HttpClient) { }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }
  
  CreateTaskComment(tenantId: number, taskId: number, comments:CreateComments): Observable<any> {
    return this.http.post(`${environment.BASE_URL}/tenants/${tenantId}/tasks/${taskId}/comments`, comments, this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        })
        , catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError());
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  DeleteTaskComment(tenantId: number, taskId: number, commentId:number): Observable<any> {
    return this.http.delete(`${environment.BASE_URL}/tenants/${tenantId}/tasks/${taskId}/comments/${commentId}`, this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        })
        , catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError());
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }
}
